"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { createHistory, useBasename, useQueries } from "history";
import parsePath from "history/lib/parsePath";
const history = useQueries(useBasename(createHistory))({
  basename: "/app"
});
export default history;
export function push(path, query = null, state = null) {
  history.push(__spreadProps(__spreadValues({}, parsePath(path)), { query, state }));
}
export function replace(path, query = null, state = null) {
  history.replace(__spreadProps(__spreadValues({}, parsePath(path)), { query, state }));
}
